import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import { Box, Tooltip, TextField, Popover, Typography, Button, FormHelperText } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';

import { apiList, getCancelData } from '../../api/callAPI';

import useUser from '../../hook/useUser';
import useGlobalStatus from '../../hook/useGlobalStatus';
import useAllUserList from '../../hook/useAllUserList';

import * as urlConstants from '../../constants/url';
import * as alertConstants from '../../constants/alertMsg';

import { AutocompleteStyle, PaperStyle } from './sendListStyled';

import { handleColorSystem } from '../customComponent/colorSystem';
import { SwitchAccountIcon, KeyboardArrowDownOutlinedIcon } from '../../constants/images';

import { MODAL_SEND_LIST } from '../modal/constants';

import { checkEmail } from '../formData/formData';

import theme from '../../theme';

const filter = createFilterOptions();

const TransferReport = (props) => {
  const {
    media,
    row,
    setIsLoadingData,
    setModalName,
    fetchData,
    setPage,
  } = props;

  const history = useHistory();
  const intl = useIntl();
  const { currentActiveData, setCurrentActiveData, locale, setModalContent, isModalOpen, setIsModalOpen, modalContent, modalData, setModalData } = useGlobalStatus();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { allUserList, selectedUser, setSelectedUser } = useAllUserList();
  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = handleColorSystem(media);
  const [anchorEl, setAnchorEl] = useState(null);
  const popOpen = Boolean(anchorEl);
  const [inputErrorMsg, setInputErrorMsg] = useState('');


  const handleUserChange = (event, newValue) => {
    setSelectedUser(newValue);
  };

  const fetchTransReport = (cancelToken) => {
    if (!selectedUser) {
      setInputErrorMsg(<FormattedMessage id="sendList.transferReport.placeholder.enterEmail" />);
      return;
    };

    const isValidEmail = checkEmail(selectedUser.email ? selectedUser.email : selectedUser);

    if (!isValidEmail) {
      setInputErrorMsg(<FormattedMessage id="sendList.transferReport.invalidEmailFormat" />);
      return;
    };

    handleCloseTrans();
    setIsLoadingData(true);

    const requestData = {
      reportid: row.weeklyReportId,
      userid: selectedUser.userId
    };

    apiList.transReports(requestData, cancelToken)
      .then(res => {
        if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;
        if (res.status === 200) {
          setIsLoadingData(false);
          setModalContent({ ...MODAL_SEND_LIST['completeTransReports'], media: media })
          setModalData({ weeklyReportName: row.weeklyReportName })
          setIsModalOpen(true);

          setTimeout(() => {
            setIsModalOpen(false);
            fetchData();
          }, 2000);

        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          setModalContent({ ...MODAL_SEND_LIST['failedTransReports'], media: media })
          setIsModalOpen(true);
          setIsLoadingData(false);

          setTimeout(() => {
            setIsModalOpen(false);
            fetchData();
          }, 3000)
        };
      });
  };

  const handleCloseTrans = () => {
    setInputErrorMsg('');
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={<FormattedMessage id="sendList.transferReport.button" />} placement="bottom">
        <SwitchAccountIcon
          variant="dark"
          sx={{
            cursor: 'pointer',
            '&:hover': { color: mainColor }
          }}
          onClick={(e) => {
            setCurrentActiveData(row);
            setAnchorEl(e.currentTarget);
          }}
        />
      </Tooltip>
      {
        <Popover
          open={popOpen}
          anchorEl={anchorEl}
          onClose={handleCloseTrans}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Box sx={{ width: '520px', padding: '16px' }} >
            <Typography variant='body2'>
              <FormattedMessage id="sendList.transferReport.chooseNewOwner" />
            </Typography>

            <AutocompleteStyle
              freeSolo
              size="small"
              name="allUserList"
              options={allUserList}
              value={selectedUser}
              onChange={handleUserChange}
              // filterOptions={handleFilterOption}
              getOptionLabel={(option) => {
                // if (typeof option === 'string') {
                //   return option;
                // }
                // if (option.inputValue) {
                //   return option.inputValue;
                // }
                return `${option.name} <${option.email}>`;
              }}
              renderOption={(props, option) => (
                <Box component="li" sx={{ fontSize: '0.875rem' }} {...props}>
                  {`${option.name} <${option.email}>`}
                </Box>
              )}
              noOptionsText={<FormattedMessage id="sendList.transferReport.noOptions" />}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              renderInput={(params) => (
                <TextField {...params} placeholder={intl.formatMessage({ id: "sendList.transferReport.placeholder.enterEmail" })} />
              )}
              PaperComponent={(props) => (
                <PaperStyle {...props} />
              )}
              popupIcon={<KeyboardArrowDownOutlinedIcon />}
            />

            <FormHelperText error>{inputErrorMsg}</FormHelperText>

            <Box
              sx={{
                textAlign: 'end',
                marginTop: '12px'
              }}
            >
              <Button
                variant="text-cancel"
                sx={{ fontSize: '0.875rem' }}
                onClick={handleCloseTrans}
              >
                <FormattedMessage id="common.button.cancel" />
              </Button>

              <Button
                variant="fill-create"
                sx={{
                  color: '#fff',
                  fontSize: '0.875rem',
                  backgroundColor: mainColor,
                  '&:hover': {
                    backgroundColor: darkColor,
                  }
                }}
                onClick={() => fetchTransReport()}
              >
                <FormattedMessage id="sendList.transferReport.button" />
              </Button>
            </Box>

          </Box>
        </Popover>
      }
    </>
  )
}

export default TransferReport;